export const BIRDVIEW_SPARKLINE_TOOLTIP_PROPS = { offset: 0 }
